import { z } from 'zod'

/**
 * Skillmatrix-blok in de onboarding-stap Vakbekwaamheid. De kandidaat beoordeelt
 * zichzelf; bij goedkeuring door HR landt dit als `EmployeeSkill.eigenBeoordeling`.
 * De naam reist mee zodat HR de ingevulde stap kan lezen; de server herschrijft
 * hem bij indienen vanuit de catalogus.
 */
export const onboardingSkillBeoordelingSchema = z.object({
  skillId: z.string().min(1).max(64),
  naam: z.string().max(200),
  niveau: z.number().int().min(0).max(10),
})
export type OnboardingSkillBeoordeling = z.infer<typeof onboardingSkillBeoordelingSchema>

export const onboardingSkillBeoordelingenSchema = z.array(onboardingSkillBeoordelingSchema).max(1000)

export const ONBOARDING_SKILLS_VELD = 'skillBeoordelingen'

export interface OnboardingSkillDTO {
  id: string
  naam: string
  schaalMin: number
  schaalMax: number
}

export interface OnboardingSkillSectieDTO {
  id: string
  /** Null = skills die direct onder de hoofdgroep hangen. */
  naam: string | null
  skills: OnboardingSkillDTO[]
}

export interface OnboardingSkillGroepDTO {
  id: string
  naam: string
  secties: OnboardingSkillSectieDTO[]
}

export interface OnboardingSkillBlokDTO {
  groepen: OnboardingSkillGroepDTO[]
  /** Bestaande eigen beoordeling (overname van een bestaande medewerker). */
  eigen: OnboardingSkillBeoordeling[]
}
